<template>
  <div>
    <v-row no-gutters align="center">
      <v-col>
        <dialog-page-search :text.sync="search" :loading="searchLoading"/>
      </v-col>
      <v-col cols="auto" class="pr-2">
        <v-btn icon depressed @click="createChatOpen=true">
          <v-icon small>mdi-message-text</v-icon>
        </v-btn>
        <v-btn icon depressed @click="settings=true">
          <v-icon small>mdi-cog</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-divider/>
    <dialog-page-create-chat :open="createChatOpen" @cancel="createChatOpen=false" @created="(v)=>v ? localSelectChat = v : null"/>
    <dialog-page-settings :open="settings" :height="height" @cancel="settings=false"/>
    <div v-if="$tools.isEmpty(search)">
      <v-row no-gutters>
        <v-col>
          <v-tabs v-model="tab" background-color="transparent" fixed-tabs height="54px">
            <v-tab v-for="(v,k) in localCats" :key="k" class="pa-0" style="min-width: 0">
              <dialog-page-nav-tab-item
                  :unreadCount="v.unreadCount"
                  :searchCount="v.searchCount"
                  :icon="v.icon"
                  :loading="v.loading"
                  :name="v.name"
              />
            </v-tab>
          </v-tabs>
        </v-col>
        <v-col align-self="center" cols="auto">
          <v-menu offset-y right>
            <template v-slot:activator="{ attrs, on }">
              <v-btn class="mx-1" icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <radios
                :items="[{id:'my',name:'Мои чаты'},{id:'all',name:'Чаты всех пользователей'}]"
                :select.sync="filterView"
                class="mb-0"
            />
          </v-menu>
        </v-col>
      </v-row>
      <v-divider/>
      <div v-for="(v,k) in localCats" :key="k">
        <dialog-page-chats
            v-show="tab===k"
            :cat="v"
            :filterView="filterView"
            :height="height-48-54-1-1"
            :search="search"
            :selectChat.sync="localSelectChat"
            @loading="(v1)=>v.loading=v1"
            @unreadCount="(v1)=>v.unreadCount=v1"
            @searchCount="(v1)=>v.searchCount=v1"
        />
      </div>
    </div>
    <div v-else>
      <dialog-page-chats
          :height="height-48-54-1-1"
          :search="search"
          @loading="(v1)=>searchLoading=v1"
          :selectChat.sync="localSelectChat"
      />
    </div>
  </div>
</template>

<script>
import DialogPageSearch from "./DialogPageSearch.vue";
import Radios from "../../../../componentsV2/base/Radios.vue";
import DialogPageChats from "./DialogPageChats.vue";
import DialogPageNavTabItem from "./DialogPageNavTabItem.vue";
import DialogPageCreateChat from "./DialogPageCreateChat.vue";
import DialogPageSettings from "./DialogPageSettings.vue";

export default {
  components: {
    DialogPageNavTabItem,
    DialogPageChats,
    Radios,
    DialogPageSearch,
    DialogPageCreateChat,
    DialogPageSettings,
  },
  props: ['height', 'cats', 'selectChat'],
  data: () => ({
    tab: 0,
    search: null,
    searchLoading: false,
    localCats: [],
    filterView: null,
    localSelectChat: null,
    createChatOpen: false,
    settings: false,
  }),
  mounted() {
    this.tab = parseInt(this.$tools.storageGet('dialogPageNav_tab', 0));
    this.filterView = this.$tools.storageGet('dialogPageNav_filterView', {id: 'my', name: 'Мои чаты'});
    this.localCats = [
      {id: 'internal', name: 'Рабочий', icon: 'mdi-account-tie', unreadCount: 0, searchCount: 0, loading: false},
      {id: 'queue', name: 'Очередь', icon: 'mdi-account-question', unreadCount: 0, searchCount: 0, loading: false},
      {id: 'process', name: 'Обработка', icon: 'mdi-account-clock', unreadCount: 0, searchCount: 0, loading: false},
      {id: 'closed', name: 'Закрытые', icon: 'mdi-account-remove', unreadCount: 0, searchCount: 0, loading: false},
    ];
  },
  watch: {
    tab() {
      this.$tools.storageSet('dialogPageNav_tab', this.tab)
    },
    filterView() {
      this.$tools.storageSet('dialogPageNav_filterView', this.filterView)
    },
    cats() {
      this.localCats = this.cats
    },
    localCats() {
      this.$emit('update:cats', this.localCats)
    },
    selectChat() {
      this.localSelectChat = this.selectChat
    },
    localSelectChat() {
      this.$emit('update:selectChat', this.localSelectChat)
    },
  },
  methods: {
    /*
    loadPage(cat) {
      cat.state.stateLoading();
      axios.get('/napi/dialog/chat/?cat='+cat.id+(this.$tools.isEmpty(this.search) ? '' : '&q='+this.search))
          .then(r => {
            r.data.forEach(v=> this.onDialogChat(v))
            cat.state.stateSuccess();
          })
          .catch(()=>{
            cat.state.stateError();
          });
    },
    onDialogChat(data, isEvent = false){
      const index = this.chats.findIndex(v => v.id === data.id);
      data.blink = isEvent;

      if(index===-1) this.chats.push(data);
      else this.chats[index] = data;

      if(isEvent)
        setTimeout(()=>{
          const index = this.chats.findIndex(v => v.id === data.id);
          if(index!==-1) this.chats[index].blink = false;
        }, 2000)

      this.chats = this.chats.sort((a, b)=>{
        let a1 = a.dialogMesLast ? 10000+a.dialogMesLast.id : + a.id;
        let b1 = b.dialogMesLast ? 10000+b.dialogMesLast.id : + b.id;
        if(a1===b1) return 0;
        return a1>b1 ? -1 : 1;
      })

      this.cats.forEach((cat, k)=>{
        this.cats[k].unreadCount = this.chats.filter(chat=>chat.cat===cat.id && chat._unreadCount>0).length
      })
    }

     */
  }
}
</script>